import React from "react";
import { BiSolidQuoteAltLeft, BiSolidQuoteAltRight } from "react-icons/bi";
import img from "../../assets/author-2-55x56 1.png";
const Message = () => {
  return (
    <>
      <div className="bg-[#F8FCFA]">
        <div className="flex flex-col items-center px-6 xl:px-0 py-24">
          <div className="xl:w-2xl">
            <div className="">
              <div className="font-bold text-3xl sm:text-4xl text-center mb-4">
                Message from the CEO{" "}
              </div>
              <div className="font-light text-base text-center mb-20">
                Discover our vision for connecting communities and empowering businesses across Nepal.{" "}
              </div>{" "}
            </div>
            <div className="flex flex-col items-center">
              {" "}
              <div className="rounded-2xl bg-white shadow-md xl:px-24 pb-10 pt-20 md:w-4/5 relative">
                <div className="absolute right-[35%] md:right-[44%] -top-14">
                  <img src={img} alt="message" />
                </div>
                <div className="font-light text-base sm:text-xl flex">
                  <div className="text-center mb-8 px-4 relative">
                    {" "}
                    <span className="inline-block align-top">
                      <BiSolidQuoteAltLeft
                        size={29}
                        className="text-[#16A951]"
                      />
                    </span>
                    <span className="inline">
                      KAHA is more than just a platform—it's a bridge connecting communities, businesses, and opportunities across Nepal. Our mission is to make every Heritage, Tourist places, Home, Business, and Organization easily discoverable and accessible. With features like interactive maps, digital profiles, QR-based navigation, and multilingual support, we're transforming how people find and connect with the places that matter. I'm incredibly proud of what we've built and excited about the positive impact KAHA is making in communities nationwide.
                    </span>
                    <span className="inline-block align-bottom">
                      <BiSolidQuoteAltRight
                        size={29}
                        className="text-[#16A951]"
                      />
                    </span>
                  </div>
                </div>
                <div className="font-bold text-xl text-center text-[#16A951]">
                  Narayan Chhetri
                </div>
                <div className="font-normal text-base text-center">
                  CEO & Founder @KAHA
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Message;
